import moment from 'moment'

class OutOfOfficeController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    "ngInject";
    this.name = 'OutOfOfficeModal';
    this.$scope = $scope

    /** Calendar configuration */
    this.minDate = moment();
    this.maxDate = moment().add(10, 'years').format('YYYY-MM-DD');

    // Leave Charge Code Options
    $scope.leaveChargeCodes = $uibModalInstance.leaveChargeCodes || []

    const existingOutOfOffice = $uibModalInstance.outOfOffice
    if (existingOutOfOffice && existingOutOfOffice.id) {
      $scope.exists = true
      $scope.outOfOffice = this.getExistingOutOfOffice(existingOutOfOffice, $scope.leaveChargeCodes)
    } else {
      $scope.exists = false
      $scope.outOfOffice = this.getNewOutOfOffice($scope.leaveChargeCodes)
    }

    // Initialize date text inputs
    this.startDateTextUpdating = false;
    this.endDateTextUpdating = false;
    this.updateDateTexts();

    // Watch for changes to dates and update text inputs (only when not manually editing)
    $scope.$watch(() => this.$scope.outOfOffice.startDate, (newVal, oldVal) => {
      if (!this.startDateTextUpdating && newVal !== oldVal) {
        if (newVal) {
          this.startDateText = moment(newVal).format('MMM DD, YYYY');
        } else {
          this.startDateText = '';
        }
      }
    });

    $scope.$watch(() => this.$scope.outOfOffice.endDate, (newVal, oldVal) => {
      if (!this.endDateTextUpdating && newVal !== oldVal) {
        if (newVal) {
          this.endDateText = moment(newVal).format('MMM DD, YYYY');
        } else {
          this.endDateText = '';
        }
      }
    });

    $scope.cancel = () => {
      $scope.outOfOffice = this.getNewOutOfOffice($scope.leaveChargeCodes)
      $uibModalInstance.cancel()
    };

    $scope.save = () => {
      const { startDate, endDate, autoSubmitTimesheet } = $scope.outOfOffice
      const leaveChargeCodeId = $scope.outOfOffice.leaveChargeCode
        ? $scope.outOfOffice.leaveChargeCode.id
        : null

      const body = {
        startDate: moment(startDate).format('yyyy-MM-DD'),
        endDate: moment(endDate).format('yyyy-MM-DD'),
        autoSubmitTimesheet,
        leaveChargeCodeId,
        id: $scope.outOfOffice.id,
      }

      if ($scope.exists) {
        $http.put(`${$rootScope.apiHost}/api/users/me/out-of-office`, body, {withCredentials: true}).then((success) => {
          $uibModalInstance.success(success.data)
        }, (failure) => {
          $scope.errorMessage = failure.data.message
        })
      } else {
        $http.post(`${$rootScope.apiHost}/api/users/me/out-of-office`, body, {withCredentials: true}).then((success) => {
          $uibModalInstance.success(success.data)
        }, (failure) => {
          $scope.errorMessage = failure.data.message
        })
      }
    }

    $scope.deactivate = () => {
      $http.post(`${$rootScope.apiHost}/api/users/me/out-of-office/deactivate`, {}, {withCredentials: true}).then((success) => {
        $uibModalInstance.success({})
      }, (failure) => {
        $scope.errorMessage = failure.data.message
      })
    }

    $scope.missingRequiredValues = () => {
      const hasDates = $scope.outOfOffice.startDate && $scope.outOfOffice.endDate
      // If charge codes are available, one must be selected (not empty string, null, or undefined)
      const hasChargeCode = $scope.leaveChargeCodes.length === 0 || 
        ($scope.outOfOffice.leaveChargeCode && 
         $scope.outOfOffice.leaveChargeCode !== '' && 
         typeof $scope.outOfOffice.leaveChargeCode === 'object')
      return !hasDates || !hasChargeCode
    }

  }

  onStartDateSelected(selectedDate) {
    if (this.$scope.$$phase || this.$scope.$root.$$phase) {
      // Already in digest cycle, update directly
      this.$scope.outOfOffice.startDate = moment(selectedDate).toDate();
    } else {
      // Not in digest cycle, use $apply
      this.$scope.$apply(() => {
        this.$scope.outOfOffice.startDate = moment(selectedDate).toDate();
      });
    }
  }

  onEndDateSelected(selectedDate) {
    if (this.$scope.$$phase || this.$scope.$root.$$phase) {
      // Already in digest cycle, update directly
      this.$scope.outOfOffice.endDate = moment(selectedDate).toDate();
    } else {
      // Not in digest cycle, use $apply
      this.$scope.$apply(() => {
        this.$scope.outOfOffice.endDate = moment(selectedDate).toDate();
      });
    }
  }

  onStartDateTextChange() {
    this.startDateTextUpdating = true;
    if (this.startDateText) {
      const parsedDate = moment(this.startDateText, ['MMM DD, YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD', 'MM-DD-YYYY'], true);
      if (parsedDate.isValid()) {
        // ng-change is already in digest cycle, so we can update directly
        this.$scope.outOfOffice.startDate = parsedDate.toDate();
        // Format the text to standard format after successful parse
        this.startDateText = parsedDate.format('MMM DD, YYYY');
      }
    } else {
      // ng-change is already in digest cycle, so we can update directly
      this.$scope.outOfOffice.startDate = null;
    }
    this.startDateTextUpdating = false;
  }

  onEndDateTextChange() {
    this.endDateTextUpdating = true;
    if (this.endDateText) {
      const parsedDate = moment(this.endDateText, ['MMM DD, YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD', 'MM-DD-YYYY'], true);
      if (parsedDate.isValid()) {
        // ng-change is already in digest cycle, so we can update directly
        this.$scope.outOfOffice.endDate = parsedDate.toDate();
        // Format the text to standard format after successful parse
        this.endDateText = parsedDate.format('MMM DD, YYYY');
      }
    } else {
      // ng-change is already in digest cycle, so we can update directly
      this.$scope.outOfOffice.endDate = null;
    }
    this.endDateTextUpdating = false;
  }

  updateDateTexts() {
    this.startDateText = this.$scope.outOfOffice && this.$scope.outOfOffice.startDate
      ? moment(this.$scope.outOfOffice.startDate).format('MMM DD, YYYY')
      : '';
    this.endDateText = this.$scope.outOfOffice && this.$scope.outOfOffice.endDate
      ? moment(this.$scope.outOfOffice.endDate).format('MMM DD, YYYY')
      : '';
  }

  getStartDateButtonText() {
    if (this.$scope.outOfOffice && this.$scope.outOfOffice.startDate) {
      return moment(this.$scope.outOfOffice.startDate).format('MMM DD, YYYY');
    }
    return 'Select Start Date';
  }

  getEndDateButtonText() {
    if (this.$scope.outOfOffice && this.$scope.outOfOffice.endDate) {
      return moment(this.$scope.outOfOffice.endDate).format('MMM DD, YYYY');
    }
    return 'Select End Date';
  }

  getEndDateMinDate() {
    // End date should be at least the start date
    if (this.$scope.outOfOffice && this.$scope.outOfOffice.startDate) {
      return moment(this.$scope.outOfOffice.startDate).format('YYYY-MM-DD');
    }
    return this.minDate;
  }

  isStartDateSelected() {
    return !!(this.$scope.outOfOffice && this.$scope.outOfOffice.startDate);
  }


  getExistingOutOfOffice(outOfOffice, leaveChargeCodes) {
    const leaveChargeCode = leaveChargeCodes.find(cc => cc.id === outOfOffice.leaveChargeCodeId)

    return {
      startDate: moment(outOfOffice.startDate).local().toDate(),
      endDate: moment(outOfOffice.endDate).local().toDate(),
      autoSubmitTimesheet: outOfOffice.autoSubmitTimesheet,
      id: outOfOffice.id,
      leaveChargeCode,
    }
  }

  getNewOutOfOffice(leaveChargeCodes) {
    let defaultLeaveChargeCode = null
    // If there is only 1, default to it
    if (leaveChargeCodes.length === 1) {
      defaultLeaveChargeCode = leaveChargeCodes[0]
    }
    // If there are more than 1, default to PTO
    else if (leaveChargeCodes.length > 1) {
      defaultLeaveChargeCode = leaveChargeCodes.find(cc => cc.name === 'PTO' || cc.id === 31)
    }

    return {
      autoSubmitTimesheet: false,
      startDate: null,
      endDate: null,
      leaveChargeCode: defaultLeaveChargeCode,
    }
  }
}

export default OutOfOfficeController;



// WEBPACK FOOTER //
// ./client/pages/timesheet/modals/out-of-office/out-of-office.controller.js